module.exports = __webpack_public_path__ + "static/media/identify.8e41ca0f.png";